import React from "react";
import { Empty } from "antd";
import type { DataLiteColumn } from "../types";

type DataLiteTableProps<T> = {
  columns: DataLiteColumn<T>[];
  data: T[];
  rowKey: (item: T) => string;
  emptyText?: string;
};

function DataLiteTable<T>({
  columns,
  data,
  rowKey,
  emptyText = "No data available.",
}: DataLiteTableProps<T>) {
  if (data.length === 0) {
    return (
      <div className="data-lite-empty">
        <Empty description={emptyText} />
      </div>
    );
  }

  return (
    <div className="data-lite-table-wrap">
      <table className="data-lite-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} className={column.className}>
                {column.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={rowKey(item)}>
              {columns.map((column) => (
                <td
                  key={column.key}
                  className={column.className}
                  data-label={column.title}
                >
                  {column.render(item)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DataLiteTable;
